import script from "./ProductionTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionTab.vue?vue&type=script&setup=true&lang=js"

import "./ProductionTab.vue?vue&type=style&index=0&id=fa7501ee&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa7501ee"]])

export default __exports__